export const tableHeaderReceivedTxtHistoryTable = [
  {
    headerStyles: 'w-[20%]',
    rowStyles: 'w-[20%] py-5 break-all pl-2 align-top',
    name: 'Sender',
    label: 'Sender',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[20%]',
    rowStyles: 'w-[20%] py-5 break-all pl-2 align-top',
    name: 'Receiver',
    label: 'receiver',
    isFilter: true,
    isFilterDate: true,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[20%]',
    rowStyles: 'w-[20%] py-5 break-all pl-2 align-top',
    name: 'Received At',  // Only show the name
    label: 'received_at',  // Date store in database
    isFilter: false,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[40%]',
    rowStyles: 'w-[40%] py-5 pl-2 break-all align-top pr-10',
    name: 'Content',
    label: 'content',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
]